import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LegalLayout from "../../layouts/LegalLayout";

const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LegalLayout>
      <Box sx={{ py: 4 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          {t("legal.legalNotice.title")}
        </Typography>
        <Typography variant="body1">
          <strong>{t("legal.legalNotice.intro")}</strong>
          <br />
          <br />
          <strong>1. {t("legal.legalNotice.purpose")}</strong>
          <br />
          {t("legal.legalNotice.purposeDescription")}
          <br />
          <br />
          <strong>2. {t("legal.legalNotice.identification")}</strong>
          <br />
          {t("legal.legalNotice.companyInfo.name")}
          <br />
          {t("legal.legalNotice.companyInfo.nif")}
          <br />
          {t("legal.legalNotice.companyInfo.address")}
          <br />
          {t("legal.legalNotice.companyInfo.contact")}
          <br />
          <br />
          <strong>3. {t("legal.legalNotice.communication")}</strong>
          <br />
          {t("legal.legalNotice.communicationDescription")}
          <br />
          <br />
          <strong>4. {t("legal.legalNotice.termsOfUse.title")}</strong>
          <br />
          {t("legal.legalNotice.termsOfUse.description")}
          <br />
          <br />
          <strong>
            5. {t("legal.legalNotice.intellectualProperty.title")}
          </strong>
          <br />
          {t("legal.legalNotice.intellectualProperty.description")}
          <br />
          <br />
          <strong>6. {t("legal.legalNotice.jurisdiction.title")}</strong>
          <br />
          {t("legal.legalNotice.jurisdiction.description")}
        </Typography>
      </Box>
    </LegalLayout>
  );
};

export default LegalNotice;
